// extracted by mini-css-extract-plugin
export default {"inline":"styles_inline__JxCd4"};